import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  headerButtonConfig,
  HeaderButtonConfigType,
  LabelsAndNotesSection,
  LabelsOrNotes,
} from '../../side-panel.constants';
import {
  emptyNotesAndLabels,
  LabelsAndNotes,
} from './../../side-panel.constants';
import {
  mediumLinkIconConfig,
  smallLinkIconConfig,
} from './side-panel-labels-notes.constants';
@Component({
  selector: 'side-panel-labels-and-notes',
  templateUrl: './side-panel-labels-and-notes.component.html',
  styleUrls: ['./side-panel-labels-and-notes.component.scss'],
})
export class SidePanelLabelsAndNotesComponent implements OnInit, OnChanges {
  @Input() labelsAndNotesLabel = 'Labels & Notes';
  @Input() labelsAndNotesData: LabelsAndNotes = emptyNotesAndLabels;
  @Input() useCustom: boolean;
  @Input() showSectionHeaderBorder: boolean;
  @Input() hideHeader = false;
  @Input() labelsErrorMessage: string = null;
  @Input() notesErrorMessage: string = null;
  @Input() showEditNotesButtonAtBottom;
  @Output() addNewButtonClicked: EventEmitter<LabelsOrNotes> =
    new EventEmitter();
  @Output() editButtonClicked: EventEmitter<LabelsOrNotes> = new EventEmitter();

  sections: LabelsAndNotesSection[];
  buttonConfigs: HeaderButtonConfigType;
  infoIsShowing = false;
  infoKey: LabelsOrNotes;
  public mediumLinkIconConfig = mediumLinkIconConfig;
  public smallLinkIconConfig = smallLinkIconConfig;

  handleAddNew(whatToAdd: LabelsOrNotes) {
    this.addNewButtonClicked.emit(whatToAdd);
  }

  handleEdit(whatToEdit: LabelsOrNotes) {
    this.editButtonClicked.emit(whatToEdit);
  }

  handleInfo(whatInfo: LabelsOrNotes) {
    this.infoIsShowing = true;
    this.infoKey = whatInfo;
  }
  ngOnInit(): void {
    const labelsAndNotesData = this.labelsAndNotesData?.notes;

    this.buttonConfigs = headerButtonConfig;
    this.buttonConfigs.labels.content = this.labelsAndNotesData?.labels?.title;
    this.buttonConfigs.notes.content =
      labelsAndNotesData?.addNoteContent || labelsAndNotesData?.title;

    // Check for property to allow for null overrides
    if (labelsAndNotesData) {
      if (Object.hasOwn(labelsAndNotesData, 'icon')) {
        this.buttonConfigs.notes.icon = labelsAndNotesData?.icon;
      }

      if (labelsAndNotesData?.level) {
        this.buttonConfigs.notes.level = labelsAndNotesData.level;
      }

      this.sections = Object.entries(this.labelsAndNotesData).map(
        ([key, value]) =>
          ({
            key: key,
            title: value.title,
            data: value.data,
            showButton: !value.data || value.data.length === 0,
            hideInfoIcon: value.hideInfoIcon,
          }) as LabelsAndNotesSection,
      );
    }
  }

  ngOnChanges(): void {
    if (this.labelsAndNotesData) {
      this.sections = Object.entries(this.labelsAndNotesData).map(
        ([key, value]) =>
          ({
            key: key,
            title: value.title,
            data: value.data,
            showButton: !value.data || value.data.length === 0,
            hideInfoIcon: value.hideInfoIcon,
          }) as LabelsAndNotesSection,
      );
    }
  }
}
